import { render, staticRenderFns } from "./memberActive.vue?vue&type=template&id=61dafba1&scoped=true&"
import script from "./memberActive.vue?vue&type=script&lang=js&"
export * from "./memberActive.vue?vue&type=script&lang=js&"
import style0 from "./memberActive.vue?vue&type=style&index=0&id=61dafba1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61dafba1",
  null
  
)

export default component.exports